import svgPanZoom from 'svg-pan-zoom'
import hammerHandler from '../derby/zoom/hammer_handler'

import { resetTooltip } from '../shared/tooltip'

var panZoomInstance  = null
function setTooltip() {
  let tooltip = document.getElementById('svg-tooltip')
  if (tooltip) {
    tooltip.style.display = 'block'
    resetTooltip(tooltip)
  }
}

function hideTooltip() {
  let tooltip = document.getElementById('svg-tooltip')
  if (tooltip) {
    tooltip.style.display = 'none'
  }
}


function setSvgZoom() {
  var svg = document.querySelector('.rightsidemap #Layer_1')
  if (!svg) return
  var height = document.querySelector('.rightsidemap').offsetHeight
  panZoomInstance = svgPanZoom('.rightsidemap #Layer_1', {
    panEnabled: true,
    controlIconsEnabled: false,
    zoomEnabled: true,
    dblClickZoomEnabled: true,
    mouseWheelZoomEnabled: false,
    preventMouseEventsDefault: true,
    zoomScaleSensitivity: 0.2,
    minZoom: 0.5,
    maxZoom: 3,
    fit: false,
    contain: false,
    center: false,
    refreshRate: 'auto',
    eventsListenerElement: null,
    customEventsHandler: hammerHandler
  })


  $('.rightsidemap').css('height', `${height}px`)
  setTooltip()
}


$(document).on('turbolinks:load', function() {
  setSvgZoom()
  $(document).on('click', '.zoomIn', function() {
    panZoomInstance.zoom(panZoomInstance.getZoom()+0.2)
    hideTooltip()
  })

  $(document).on('click', '.zoomOut', function() {
    panZoomInstance.zoom(panZoomInstance.getZoom()-0.2)
    hideTooltip()
  })

  $(document).on('mouseover', '.group-package', function() {
    panZoomInstance.reset()
    setTooltip()
  })

  $(document).on('wheel', '.rightsidemap #Layer_1', function() {
    var max_width = window.matchMedia('(max-width: 768px)')
    if(max_width.matches) {
      panZoomInstance.enableMouseWheelZoom()
      hideTooltip()
    }
    else {
      panZoomInstance.disableMouseWheelZoom()
    }
  })

  $(document).on('click', '.zoomReset', function() {
    panZoomInstance.reset()
    hideTooltip()
  })
})
